import { useCallback } from 'react';
import { useHistory } from 'react-router-dom';
import { openRemoteModalWrapper } from 'src/components/pages/legacy/components/open-legacy-remote-modal-link';
import { useAuthorization } from 'src/hooks/use-authorization';
import { useUrls } from 'src/hooks/use-urls';

export const useAppointmentModal = () => {
  const { getAppointmentUrl, getScheduleModalUrl, getAddScheduleUrl } = useUrls();
  const { getFeatureFlag } = useAuthorization();
  const showInlineForm =
    getFeatureFlag('ux-redesign-v2.5') && getFeatureFlag('inline-forms-redesign');
  const history = useHistory();

  const getAppointmentModalUrl = useCallback(
    (appointmentId: number) => {
      return showInlineForm
        ? getAppointmentUrl({ appointmentId, options: { includeHost: false } })
        : getScheduleModalUrl({ scheduleId: appointmentId });
    },
    [showInlineForm, getAppointmentUrl, getScheduleModalUrl],
  );

  const showEditAppointmentModal = useCallback(
    (appointmentId: number) => {
      const appointmentModalUrl = getAppointmentModalUrl(appointmentId);

      history.push(appointmentModalUrl);
    },
    [getAppointmentModalUrl, history],
  );

  const showAddAppointmentModal = useCallback(
    ({ contactId }: { contactId?: number }) => {
      const appointmentModalUrl = getAddScheduleUrl({ contactId });

      if (showInlineForm) {
        history.push(appointmentModalUrl);
      } else {
        openRemoteModalWrapper(appointmentModalUrl);
      }
    },
    [getAddScheduleUrl, showInlineForm, history],
  );

  return { showEditAppointmentModal, getAppointmentModalUrl, showAddAppointmentModal };
};
